export const WHERE_DATASETS = ['account', 'project', 'contact'] as const;
export type WhereDataset = (typeof WHERE_DATASETS)[number];

export const WHERE_KINDS = ['text', 'choice', 'number', 'date', 'yes_no', 'score'] as const;
export type WhereKind = (typeof WHERE_KINDS)[number];

export const WHERE_CATEGORIES = [
  'firm',
  'project',
  'contact',
  'signals',
  'scores',
  'workspace',
  'views',
] as const;
export type WhereCategory = (typeof WHERE_CATEGORIES)[number];

export const CATEGORY_LABEL: Record<WhereCategory, string> = {
  firm: 'Firm',
  project: 'Project',
  contact: 'Contact',
  signals: 'Signals',
  scores: 'Scores',
  workspace: 'Your workspace',
  views: 'Saved Views',
};

export type WhereRelation = 'project' | 'contact' | 'firm' | 'signal';
export type WhereValueSource =
  | 'cities'
  | 'firm_cities'
  | 'neighborhoods'
  | 'tags'
  | 'statuses'
  | 'views';
export type WhereUnit = 'usd' | 'sqft' | 'ft' | 'units' | 'count' | 'year';

export interface WhereOption {
  value: string;
  label: string;
  description?: string;
}

/** One field a person can filter on: no SQL here, the API owns that. */
export interface WhereField {
  key: string;
  label: string;
  category: WhereCategory;
  kind: WhereKind;
  description: string;
  relation?: WhereRelation;
  options?: readonly WhereOption[];
  source?: WhereValueSource;
  unit?: WhereUnit;
}

export interface WhereRule {
  field: string;
  operator: string;
  value?: unknown;
  id?: string;
}

export interface WhereGroup {
  combinator: 'and' | 'or';
  not?: boolean;
  rules: Array<WhereRule | WhereGroup>;
  id?: string;
}

/** A table's filters: the Search chip plus the condition. */
export interface TableFilter {
  q: string;
  where: WhereGroup;
}

export const EMPTY_WHERE: WhereGroup = Object.freeze({
  combinator: 'and',
  rules: Object.freeze([]) as unknown as WhereGroup['rules'],
}) as WhereGroup;

export function isWhereGroup(node: WhereRule | WhereGroup): node is WhereGroup {
  return Array.isArray((node as WhereGroup).rules);
}
